import axios from "axios";

// Same-origin: o proxy da plataforma encaminha /api ao backend em qualquer host
// (preview, domínio próprio e www) — evita bloqueio de CORS ao salvar pelo domínio próprio
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Sessão não expira: em 401, renova os cookies automaticamente e refaz o pedido
let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const config = error?.config;
    const isAuthCall = config?.url?.includes("/auth/");
    if (error?.response?.status === 401 && config && !isAuthCall && !config._retried) {
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh", {}, { withCredentials: true });
        await refreshing;
        refreshing = null;
        return api(config);
      } catch (e) {
        refreshing = null;
        if (!window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const todayStr = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
